import {useGetCongenereEligibilityQuery} from 'presentation/pages/private/home/query/useGetCongenereEligibilityQuery';
import {useCongenereEligibilityStore} from 'presentation/pages/private/store/useCongenereEligibilityStore';
import {wasDrawerDismissedToday} from 'presentation/utils';
import React, {useEffect} from 'react';

export function useCongenereDrawer() {
	const {data: congenereEligibilityData, isLoading} = useGetCongenereEligibilityQuery();
	const {
		congenereEligibility,
		setCongenereEligibility,
		congenereDrawerDismissedDate,
		setCongenereDrawerDismissedDate,
	} = useCongenereEligibilityStore();
	const [open, setOpen] = React.useState(false);

	function markDrawerAsDismissedToday(): void {
		setCongenereDrawerDismissedDate(new Date().toDateString());
	}

	useEffect(() => {
		if (congenereEligibilityData) {
			setCongenereEligibility(congenereEligibilityData);
		}
	}, [congenereEligibilityData, setCongenereEligibility]);

	useEffect(() => {
		if (congenereEligibility && !wasDrawerDismissedToday(congenereDrawerDismissedDate)) {
			setOpen(true);
		}
	}, [congenereEligibility, congenereDrawerDismissedDate]);

	return {open, setOpen, markDrawerAsDismissedToday, isLoading};
}
